import { render, staticRenderFns } from "./PrescriptionsTable.vue?vue&type=template&id=3faa2492&"
import script from "./PrescriptionsTable.vue?vue&type=script&lang=js&"
export * from "./PrescriptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports